/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToRem, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : RATINGS COUNTER SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  ratingscounter: {
    '& .collapsable.opened': {
      maxHeight: pxToRem(3000)
    },
    '& .codepiece': {
      '& p.description': {
        marginTop: pxToRem(8),
        height: '100%',
        color: 'rgb(22, 51, 124)'
      },
      '& .group': {
        '& .field': {
          marginBottom: pxToRem(8),
          marginTop: pxToRem(16),
          '& .formelement': {
            height: pxToRem(48)
          },
          '& input.textfield': {
            paddingTop: `${pxToRem(16)} !important`,
            fontSize: `${pxToRem(14)} !important`,
            fontWeight: 'normal'
          }
        }
      }
    },
    '& strong': {
      fontWeight: 'bold'
    },
    '& .inlinemessage': {
      marginTop: pxToRem(16)
    },
    '& .icon.message-icon': {
      color: 'rgb(152, 167, 198)',
      alignSelf: 'start',
      position: 'relative',
      top: pxToRem(1)
    },
    '& .sectiongroupdescription': {
      '& > h2': {
        marginBottom: pxToRem(8)
      },
      '& > h4': {
        color: 'rgb(22, 51, 124)'
      }
    }
  },

  // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
  [mediaQuery.thinnest]: {
    ratingscounter: {
      '& .copysnippetfield': {
        '& .buttonlink': {
          display: 'block',
          '& .link': {
            display: 'block',
            marginTop: pxToRem(8)
          }
        }
      }
    }
  }
});
